import { CodeBlockLowlight } from '@tiptap/extension-code-block-lowlight'

export const CodeBlock = CodeBlockLowlight
